import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IonLabel } from '@ionic/react'

import { Share } from '@/components/atoms/assets/Share'

export const BasicPwaOnboarding: FC = () => {
  const { t } = useTranslation('common')
  return (
    <div className="grid pt-8 mb-20">
      <IonLabel className="font-bold text-lg text-primary">
        {t('PWAOnboarding.howTodoIt')}
      </IonLabel>
      <div className="pt-4 text-base">
        <IonLabel>{t('PWAOnboarding.step1')}</IonLabel>
        <IonLabel className="text-2xl align-middle ml-2">
          <Share color="success" />
        </IonLabel>
      </div>
      <IonLabel className="mt-3.5">{t('PWAOnboarding.step2')}</IonLabel>
      <IonLabel className="mt-3.5">{t('PWAOnboarding.step3')}</IonLabel>
      <IonLabel className="text-base pt-4 font-bold text-primary">
        {t('PWAOnboarding.done')}
      </IonLabel>
    </div>
  )
}
